import type { Action, ApplyResult, GameState, GameStep, Side } from '@brig/rules-engine';
import { nextAction } from './bot.ts';

/** How the host applies one of the computer's actions: with chance it deals, or seeded. */
export type PlayStep = (
  state: GameState,
  action: Action,
) => { readonly result: ApplyResult; readonly step: GameStep };

/** The most actions the computer may take in one turn: more is a bug, not a long turn. */
export const BOT_TURN_LIMIT = 500;

/** The computer plays while its side is to move (R-TURN-*): the rest of its turn, to the end. */
export function botTurn(
  start: GameState,
  side: Side,
  play: PlayStep,
): { state: GameState; steps: GameStep[] } {
  let state = start;
  const steps: GameStep[] = [];
  while (state.status.kind === 'playing' && state.turn.side === side) {
    if (steps.length >= BOT_TURN_LIMIT) throw new Error('The computer did not end its turn');
    const { result, step } = play(state, nextAction(state, side));
    if (!result.ok) throw new Error(`The computer chose an illegal action: ${result.error.message}`);
    state = result.state;
    steps.push(step);
  }
  return { state, steps };
}
